import React from 'react';
import ReactMarkdown from 'react-markdown';

const UserSummary = ({ data }) => {
  return (
    <div>
      <div className="text-base font-bold mt-3 mb-1">
        <span>
          {data.summary.position_level !== 'Junior' && data.summary.position_level !== 'Middle'
            ? data.summary.position_level + ' '
            : ''}
        </span>
        <span>
          {data.summary.position} with {data.summary.experience}+ years of experience.
        </span>
      </div>
      <ReactMarkdown
        className="text-sm description"
        source={data.summary.body.replace(/\n/gi, '\n\n')}
      />
    </div>
  );
};

export default UserSummary;
